module.exports = __webpack_public_path__ + "static/media/narsharab-bg.06e597a1.png";